export const minifyCss = (cssContent: string) => {
  return cssContent
    .replace(/}\s*(?=[^{]*{)/g, '}')
    .replace(/\n/g, '')
    .replace(/\s*([:;,{}])\s*/g, '$1');
};
